<form [formGroup]="confirmationForm()">
    <app-modal
        [modalInput]="modal()"
        testIdContext="WaltCommandConfirmModal"
        (modalCloseOutput)="handleClose($event)"
        class="mT20 fs14p jcC"
    >
        <div class="walt-command-confirm flexColumn jcC aiFS gap20p" data-testid="WaltCommandConfirmModal">
            <div class="walt-command-confirm-description" [innerHTML]="descriptionKey() | translate"></div>
            <div class="flexColumn jcFS aiFS gap15p">
                <div class="walt-command-confirm-instruction" [innerHTML]="instructionKey() | translate"></div>
                <app-input
                    [autofocus]="true"
                    [isShowLabel]="false"
                    inputId="WaltCommandConfirmModal-Input"
                    formControlName="confirmCapture"
                    [required]="true"
                ></app-input>
            </div>
        </div>
    </app-modal>
</form>
